import { RouteObject } from 'react-router'

import { PLATFORM } from '@/constants/platform'
import { STREAMING_MENU_ICONS } from '@/router/icons'
import { HistoricalStatisticsView } from '@/views/HistoricalStatisticsView'

export const historicalStatistics: RouteObject[] = [
  {
    path: 'historical-statistics',
    label: 'Historical Statistics',
    icon: STREAMING_MENU_ICONS.HISTORICAL_STATISTICS,
    platforms: [PLATFORM.DGE],
    children: [
      {
        index: true,
        element: <HistoricalStatisticsView />,
        platforms: [PLATFORM.DGE]
      }
    ]
  }
]
